import type { Stripe } from '@stripe/stripe-js'

let stripeClientPromise: Promise<Stripe> | null = null

/** One Stripe.js load per page; a failed load resets so the next checkout retries. */
export function loadStripeClient(): Promise<Stripe> {
  if (stripeClientPromise) {
    return stripeClientPromise
  }
  const promise = (async () => {
    const { loadStripe } = await import('@stripe/stripe-js')
    const stripe = await loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)
    if (!stripe) {
      throw new Error('Stripe not loaded')
    }
    return stripe
  })()
  stripeClientPromise = promise
  promise.catch(() => {
    if (stripeClientPromise === promise) {
      stripeClientPromise = null
    }
  })
  return promise
}

export function preloadStripeClient(): void {
  loadStripeClient().catch(() => undefined)
}
